import { Modal } from 'antd'
import React, { useState } from 'react'
import LoaderSpin from '../../Common/LoaderSpin'

const SubscriptionModal = ({ openEssentialModal, setOpenEssentialModal, plan, createCustomerPortalSession }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const close = () => {
        setOpenEssentialModal(false)
        setSelectedIndex(0)
    }
    const handleClick = async () => {
        setIsLoading(true)
        await createCustomerPortalSession()
        setIsLoading(false)
    }
    const { title, price, description } = plan
    return (
        <Modal open={openEssentialModal} width={650} closeIcon={false} footer={false} onCancel={close}>

            <div className="bg-white rounded-lg p-4 w-full ">
                <h2 className="text-2xl font-semibold text-center mb-6 text-morphDarkBlue">Choose Your {title} Plan</h2>

                <div className="space-y-4">
                    <div onClick={() => { setSelectedIndex(0) }} className={` ${selectedIndex === 0 ? " border-morphDarkBlue bg-morphDarkBlue/10 " : ''} flex flex-col gap-2 rounded-lg border-2 border-gray-200 p-4 cursor-pointer transition-colors duration-200 hover:border-morphDarkBlue hover:bg-morphDarkBlue/5`}>
                        <div className="flex items-center justify-between">
                            <div className="font-semibold text-morphDarkBlue text-lg">{title} Plan</div>
                            <div className="font-bold text-morphDarkBlue text-lg">${price}<span className="text-sm font-normal text-gray-600">/month</span></div>
                        </div>
                        <div className="text-sm text-gray-600">
                            {description}
                        </div>
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="text-morphDarkBlue"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            12 Month Contract Billed Monthly
                        </div>
                    </div>

                    <div onClick={() => { setSelectedIndex(1) }} className={` ${selectedIndex === 1 ? " border-morphDarkBlue bg-morphDarkBlue/10 " : ''} flex flex-col gap-2 rounded-lg border-2 border-gray-200 p-4 cursor-pointer transition-colors duration-200 hover:border-morphDarkBlue hover:bg-morphDarkBlue/5`}>
                        <div className="flex items-center justify-between">
                            <div className="font-semibold text-morphDarkBlue text-lg">{title} with Alex AI Plan</div>
                            <div className="font-bold text-morphDarkBlue text-lg">${Number.parseFloat(price) + 5}<span className="text-sm font-normal text-gray-600">/month</span></div>
                        </div>
                        <div className="text-sm text-gray-600">
                            This plan includes all features from the {title} Plan, along with exclusive access to Alex AI for advanced screenwriting and automation.
                        </div>
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="text-morphDarkBlue"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            12 Month Contract Billed Monthly
                        </div>
                    </div>
                </div>

                <div className="mt-6 flex justify-end gap-3">
                    <button onClick={close} className="px-4 py-2 border border-morphLightBlue text-morphLightBlue rounded-md hover:bg-morphLightBlue/10 transition-colors duration-300">Cancel</button>
                    <button
                        onClick={handleClick}
                        className="px-4 py-2 bg-morphLightBlue w-[92px] text-white rounded-md hover:bg-morphDarkBlue transition-colors duration-300">
                        {isLoading? <LoaderSpin color={'white'}/> : 'Continue'}
                    </button>
                </div>
            </div>

        </Modal>
    )
}

export default SubscriptionModal